import { GridItem } from '@chakra-ui/react'
import EmailConfirmationBanner from '../../Features/Confirmation Banner/EmailConfirmationBanner'
import { useUserEmailStatus } from '../../Features/UserSettings/use-user-settings'

export default function Layout({ children }) {
  const userData = useUserEmailStatus()
  const emailConfirmedStatus = userData.data?.email_confirmed_status

  return (
    <GridItem colSpan={{ base: 2, md: 1 }}>
      {emailConfirmedStatus === 0 && (
        <GridItem colSpan={2}>
          <EmailConfirmationBanner />
        </GridItem>
      )}
      <GridItem colSpan={2}>{children}</GridItem>
    </GridItem>
  )
}
